import { useMemo } from "react";
import { PDFTableColumn } from "components/PDF/Table";
import { View, Text } from "@react-pdf/renderer";
import moment from "moment";
import { MovimentacaoBancariaItem } from "core/features/movimentacoes-bancarias/typings";
import { formatCurrency } from "@brazilian-utils/brazilian-utils";
import { OperacaoEnum } from "core/resources/enums/conta";
import colors from "core/resources/theme/colors";

function useRelatorioMovimentacaoBancariaPdfColumns(): PDFTableColumn<MovimentacaoBancariaItem>[] {
  return useMemo(() => {
    const columns: PDFTableColumn<MovimentacaoBancariaItem>[] = [
      {
        title: "Data",
        render: (original) => (
          <View>
            <Text>
              {moment(original.dataMovimentacao).format("DD/MM/YYYY")}
            </Text>
          </View>
        ),
      },
      {
        title: "Descrição",
        flexGrow: 5,
        render: (original) => (
          <View>
            <Text>{original.descricao}</Text>
          </View>
        ),
      },
      {
        title: "Valor",
        textAlign: "right",
        render: (original) => (
          <View>
            <Text
              style={{
                color:
                  original.operacao === OperacaoEnum.Despesa
                    ? colors.red
                    : undefined,
              }}
            >
              {original.operacao === OperacaoEnum.Despesa ? "- " : ""}R${" "}
              {formatCurrency(original.valorLiquido ?? original.valor)}
            </Text>
          </View>
        ),
      },
    ];

    return columns;
  }, []);
}

export default useRelatorioMovimentacaoBancariaPdfColumns;
